var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-horizontal-tabs',{attrs:{"tabs":_vm.tabs}},[_c('template',{slot:"tab-1"},[_c('enac-atpl-dashboard-learner-card-profile')],1),_vm._v(" "),_c('template',{slot:"tab-2"},[_c('enac-procedure-atp-daf-group-widget')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }